import React from "react";
import {MainCP}  from "../../Components/proyecto-graficos/MainCP"

const ViewProyectoGraficos: React.FC = () => <MainCP/>

export default ViewProyectoGraficos;